import React, { FC, useCallback } from 'react';

import { Button } from 'antd';
import dayjs from 'dayjs';
import { useLocation, useNavigate } from 'react-router-dom';
import { ABOUT_ROUTE, FAQ_ROUTE, PRICING_ROUTE } from 'routes/dashboard/list';
import { LANDING_ROUTE } from 'routes/user-management/list';
import { Icon } from 'ui';

import { MY_SERVICES_ROUTE } from 'routes/services/list';
import { serviceViewTypeSelector } from 'selectors/systemSlice.selector';
import { useAppSelector } from 'store/index';

import s from './footer.module.scss';

const Footer: FC = () => {
  const navigate = useNavigate();
  const serviceViewType = useAppSelector(serviceViewTypeSelector);
  const location = useLocation();
  const isDashboard = location.pathname.includes('dashboard');
  const goToDashboard = useCallback(() => {
    navigate(LANDING_ROUTE);
  }, [navigate]);

  const handleGoToAbout = useCallback(() => {
    navigate(ABOUT_ROUTE);
  }, [navigate]);

  const handleGoToFaq = useCallback(() => {
    navigate(FAQ_ROUTE);
  }, [navigate]);

  const handleGoToPricing = useCallback(() => {
    navigate(PRICING_ROUTE);
  }, [navigate]);

  const goToServices = useCallback(() => {
    navigate(MY_SERVICES_ROUTE);
  }, [navigate]);

  return (
    <>
      {!isDashboard && serviceViewType !== 'map' && (
        <div className={s.footerWrapper}>
          <div className={s.footerButtons}>
            <Button type="link" onClick={goToDashboard}>
              <Icon width={150} name="logo" />
            </Button>
            <div className={s.menu}>
              <Button type="link" className={s.menuItem} onClick={goToDashboard}>
                Map
              </Button>
              <Button type="link" className={s.menuItem} onClick={goToServices}>
                Services
              </Button>
              <Button type="link" className={s.menuItem} onClick={handleGoToAbout}>
                About
              </Button>
              <Button type="link" className={s.menuItem} onClick={handleGoToFaq}>
                FAQ
              </Button>
              <Button type="link" className={s.menuItem} onClick={handleGoToPricing}>
                Pricing
              </Button>
              <div className={s.socialMobile}>
                <div className={s.socialItem}>
                  <a
                    className={s.socialLink}
                    href="https://www.facebook.com/permalink.php?story_fbid=122213960738059891&id=61551796734775&notif_id=1744827562036613&notif_t=feedback_reaction_generic&ref=notif"
                    target="_blank"
                    rel="noopener noreferrer">
                    <Icon name="FBIcon" />
                  </a>
                  <a
                    className={s.socialLink}
                    href="https://instagram.com/onthatstreet"
                    target="_blank"
                    rel="noopener noreferrer">
                    <Icon name="InstaIcon" />
                  </a>
                </div>
              </div>
            </div>
            <div className={s.socialDesk}>
              <div className={s.socialItem}>
                <a
                  className={s.socialLink}
                  href="https://www.facebook.com/permalink.php?story_fbid=122213960738059891&id=61551796734775&notif_id=1744827562036613&notif_t=feedback_reaction_generic&ref=notif"
                  target="_blank"
                  rel="noopener noreferrer">
                  <Icon name="FBIcon" />
                </a>
                <a
                  className={s.socialLink}
                  href="https://instagram.com/onthatstreet"
                  target="_blank"
                  rel="noopener noreferrer">
                  <Icon name="InstaIcon" />
                </a>
              </div>
            </div>
          </div>
          <p className={s.footerCompanyText}>
            © {dayjs().year()} onthatstreet.com <br className={s.break}></br> All rights reserved.
          </p>
        </div>
      )}
    </>
  );
};
export default Footer;
